import React, { useEffect, useState } from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/TestPage';
import queryString from 'query-string';

import { validateModerationTestToken } from '../../api';
import { AliceAppTestChat } from '../AliceAppTestPage/AliceAppTestChat';
import { IndexLayout } from '../Layout/Layout';
import { PageLoader } from '../Loader/PageLoader';

import styles from './AliceSkillModerationTestPage.module.scss';

interface TAliceSkillModerationTestPageProps {
    skillId: string;
}

type Stage = 'pending' | 'failure' | 'success';

const t = i18n(keyset);

export const AliceSkillModerationTestPage: React.FC<TAliceSkillModerationTestPageProps> = ({ skillId }) => {
    const [stage, setStage] = useState<Stage>('pending');

    useEffect(() => {
        const parsed = queryString.parse(location.search);

        if (!parsed.token) {
            return setStage('failure');
        }

        validateModerationTestToken(skillId!, parsed.token as string)
            .then(() => {
                setStage('success');
            })
            .catch((err) => {
                console.error(err);
                setStage('failure');
            });
    }, [skillId]);

    const content =
        stage === 'success' ? (
            <AliceAppTestChat skillId={skillId} isDraft key="DRAFT_CHAT" />
        ) : stage === 'pending' ? (
            <PageLoader />
        ) : (
            t('link-is-outdated')
        );

    return (
        <IndexLayout hideSettings>
            <section className={styles.moderationTestPage}>{content}</section>
        </IndexLayout>
    );
};
